import {I18nText} from "../components/I18nText";

export const i18nUtil = {
  choose: (text: I18nText, displayLanguage: string) => {
    return displayLanguage === 'ja' ? text.ja : text.en
  }
};
